module.exports = __webpack_public_path__ + "img/31.b5c281a3.jpg";